import { gql } from '@apollo/client'

export const MARK_ALL_NOTIFICATIONS_READ = gql`
  mutation markAllNotificationsRead {
    markAllNotificationsRead {
      success
    }
  }
`
